import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/enterprise",
  name: "enterprise",
  redirect: {
    name: "enterprise",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "consultation",
      name: "consultation",
      meta: {
        title: "资讯动态",
      },
      component: () => import("@/pages/enterprise/consultation/index.vue"),
    },
    {
      path: "notice",
      name: "notice",
      meta: {
        title: "通知公告",
      },
      component: () => import("@/pages/enterprise/notice/index.vue"),
    },
    {
      path: "station",
      name: "station",
      meta: {
        title: "暖新服务",
      },
      component: () => import("@/pages/enterprise/station/index.vue"),
    },
    {
      path: "evaluation",
      name: "evaluation",
      meta: {
        title: "评优评先",
      },
      component: () => import("@/pages/enterprise/evaluation/index.vue"),
    },
    {
      path: "deeds",
      name: "deeds",
      meta: {
        title: "先进典型",
      },
      component: () => import("@/pages/enterprise/deeds/index.vue"),
    },
    {
      path: "homeInformation",
      name: "homeInformation",
      meta: {
        title: "首页配置",
      },
      component: () => import("@/pages/enterprise/homeInformation/index.vue"),
    },
    {
      path: "classroom",
      name: "classroom",
      meta: {
        title: "云课堂",
      },
      component: () => import("@/pages/enterprise/classroom/index.vue"),
    },
  ],
};
